<template>
    <div>
        <div class="mask" v-show="visible" @click="close"></div>
        <div class="dialog" v-show="visible">
            <div class="dialog-header">
                <img src="./../assets/2024/share.png" alt="点击上面“...”分享">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Share',
    // components: {
    //   HelloWorld
    // }
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            visible: false,
        }
    },
    watch: {
        show: {
            handler(newValue, oldValue) {
                console.log(newValue, oldValue)
                if (newValue) {
                    this.val = ''
                    document.body.classList.add('no-scroll')
                } else {
                    document.body.classList.remove('no-scroll')
                }
                this.visible = newValue
            },
            deep: true,
        }
    },
    mounted() {
        // const obj = new WxLogin({
        //   "self_redirect": true,
        //   id: "login_container", 
        //   appid: "", 
        //   scope: "", 
        //   "redirect_uri": "",
        //   state: "",
        //   style: "",
        //   href: ""
        // });
        // console.log(obj);
        this.visible = this.show
    },
    methods: {
        close() {
            this.visible = false
            this.$emit('close')
        },
    }
}
</script>
<style lang="scss" scoped>
.mask {
    animation-duration: 0.3s;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
}
.dialog {
    position: fixed;
    max-height: 100%;
    overflow-y: auto;
    width: 100%;
    transition: transform .3s;
    top: 0;
    left: 50%;
    transform: translate(-50%,0);
    .dialog-header {
        padding: 20px;
        img {
            max-width: 100%;
        }
    }
}
</style>
  